var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageCircleCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 15.5002L3.225 12.5752C2.38233 11.3289 2.0775 9.85299 2.36716 8.42191C2.65683 6.99082 3.5213 5.70194 4.79983 4.79489C6.07835 3.88784 7.68394 3.42435 9.31807 3.49061C10.9522 3.55687 12.5036 4.14836 13.684 5.1551C14.8643 6.16185 15.5932 7.51534 15.735 8.96392C15.8769 10.4125 15.4222 11.8576 14.4554 13.0305C13.4886 14.2035 12.0755 15.0244 10.4788 15.3407C8.8822 15.657 7.21065 15.4472 5.775 14.7502L2.25 15.5002",
    stroke: "#94A3B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageCircleCard);
export default __webpack_public_path__ + "static/media/message-circle-card.fb617abdcf024b5bea3d5cd7f98319c3.svg";
export { ForwardRef as ReactComponent };